import CategorySection from "./CategorySection";
import CTASection from "./CTASection";
import FeaturedSites from "./FeaturedSites";
import Hero from "./Hero";
import StatsSection from "./StatsSection";
import TopWebsites from "./TopWebsites";

const HomePage = () => (
  <>
    <Hero />
    <StatsSection />
    <FeaturedSites />
    <CategorySection />
    <TopWebsites />
    <CTASection />
  </>
);

export default HomePage;
